var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{
        name: ("revisions-list-" + _vm.type),
        params: {
            id: _vm.id
        }
    }}},[_c('div',{staticClass:"revisions"},[_c('div',{staticClass:"revisions-counter",style:({ marginRight: _vm.text ? '10px' : '' })},[_vm._v(" "+_vm._s(_vm.revisions)+" "),(_vm.revisions_count_new > 0)?_c('span',{staticClass:"revisions-new"},[_vm._v(" "+_vm._s(_vm.revisions_count_new)+" ")]):_vm._e()]),(_vm.text)?_c('span',{staticClass:"revisions-text"},[_vm._v("Revisions")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }